import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { defaultSiteChromeSettings, normalizeSiteChromeSettings } from "../utils/siteChrome";

const API = "";

function Footer() {
  const navigate = useNavigate();
  const [siteChrome, setSiteChrome] = useState(defaultSiteChromeSettings);

  useEffect(() => {
    let active = true;

    axios
      .get(`${API}/api/site-chrome-settings`)
      .then((response) => {
        if (!active) return;
        setSiteChrome(normalizeSiteChromeSettings(response.data));
      })
      .catch(() => {
        if (!active) return;
        setSiteChrome(defaultSiteChromeSettings);
      });

    return () => {
      active = false;
    };
  }, []);

  const socialItems = [
    { key: "facebook_url", href: siteChrome.facebook_url, label: "Facebook", icon: "fab fa-facebook-f", className: "fb" },
    { key: "whatsapp_url", href: siteChrome.whatsapp_url, label: "WhatsApp", icon: "fab fa-whatsapp", className: "wa" },
    { key: "instagram_url", href: siteChrome.instagram_url, label: "Instagram", icon: "fab fa-instagram", className: "ig" },
    { key: "linkedin_url", href: siteChrome.linkedin_url, label: "LinkedIn", icon: "fab fa-linkedin-in", className: "li" },
    { key: "twitter_url", href: siteChrome.twitter_url, label: "Twitter", icon: "fab fa-x-twitter", className: "tw" },
  ].filter((item) => item.href);

  return (
    <footer className="site-footer">
      <div className="site-footer__glow"></div>
      <div className="container py-5 position-relative">
        <div className="row g-4">
          <div className="col-lg-4 col-md-6">
            <div className="site-footer__card">
              <p className="site-footer__eyebrow site-footer__eyebrow--footer">{siteChrome.footer_eyebrow}</p>
              <h5>{siteChrome.footer_heading}</h5>
              <p className="site-footer__text">{siteChrome.footer_description}</p>
              <div className="site-footer__socials">
                {socialItems.map((item) => (
                  <a key={item.key} href={item.href} target="_blank" rel="noreferrer" className={`social-icon ${item.className}`} aria-label={item.label}>
                    <i className={item.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="col-lg-2 col-md-6">
            <h6 className="site-footer__heading">Quick Links</h6>
            <ul className="footer-list">
              <li onClick={() => navigate("/")}>Home</li>
              <li onClick={() => navigate("/about")}>About Us</li>
              <li onClick={() => navigate("/our-courses")}>Courses</li>
              <li onClick={() => navigate("/contact")}>Contact</li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="site-footer__heading">Student Panel</h6>
            <ul className="footer-list">
              <li onClick={() => navigate("/student-registration")}>Registration</li>
              <li onClick={() => navigate("/student-verification")}>Verification</li>
              <li onClick={() => navigate("/result-verification")}>Result</li>
            </ul>
          </div>

          <div className="col-lg-3 col-md-6">
            <h6 className="site-footer__heading">Contact Us</h6>
            <div className="site-footer__contact">
              <p>{siteChrome.footer_address}</p>
              <p>{siteChrome.footer_phone}</p>
              <p>{siteChrome.footer_email}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="site-footer__bottom">
        © 2015 - {new Date().getFullYear()} {siteChrome.footer_copyright}
      </div>
    </footer>
  );
}

export default Footer;
